import SodUserCard from './SodUserCard';

export default SodUserCard;
